// extracted by mini-css-extract-plugin
module.exports = {"user-garage":"garage_user-garage__1qlRi"};